import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { normalizeVideo } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('CLIENT.TRANSCODING.UPDATE', ['SUCCESS']);
export const NAMES = ACTIONS.NAMES;
const { SUCCESS } = ACTIONS;

export { SUCCESS };


export default function (data) {
  data = normalizeVideo(data);

  return function (dispatch) {
    dispatch(SUCCESS(data));
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/client/actions/transcoding/update.js